import React from 'react';

const SvgActions112 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M10.158 4.14a.5.5 0 0 0-.154.36v5.53L6.16 13.89a.5.5 0 0 0 0 .73 6.01 6.01 0 0 0 6.986.44A5.997 5.997 0 0 0 10.525 4a.5.5 0 0 0-.367.14zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-18C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions112 svgRef={ref} {...props} />);
export default ForwardRef;
